import DeliveryNow from './DeliveryNow';

export default DeliveryNow;
